module.exports = __webpack_public_path__ + "img/IT0001452203646.7b82f233.png";